module.exports = __webpack_public_path__ + "images/fa-brands-400.5bfa00172e97473860a96f18b340f3f5.svg";